'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import '../listeners/focusStylesListener';
import classNames from 'classnames'; // These should be removed once we have 100% adoption of UIApplication

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';
import ShareButton from '../decorators/ShareButton';
import { setupStyledComponents } from '../listeners/setupStyledComponents';
import refObject from '../utils/propTypes/refObject';
import { getTabIndex } from '../utils/TabIndex';
setupStyledComponents();

const UIClickableCore = props => {
  const {
    autoFocus,
    buttonRef,
    className,
    disabled,
    onClick,
    onKeyDown,
    tabIndex,
    tagName: Tag
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["autoFocus", "buttonRef", "className", "cursor", "disabled", "onClick", "onKeyDown", "tabIndex", "tagName"]);

  useEffect(() => {
    if (autoFocus) buttonRef.current.focus();
  }, [autoFocus, buttonRef]);

  const handleKeyDown = evt => {
    const {
      key,
      target
    } = evt;
    if (onKeyDown) onKeyDown(evt); // Ignore keydown events that bubbled up

    if (target !== buttonRef.current) return; // Simulate click on Enter/Spacebar, to emulate button behavior

    if (key === 'Enter' || key === ' ') {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      if (onClick) onClick(evt);

      if (key === ' ') {
        evt.preventDefault(); // Prevent page from scrolling (#3575)
      }
    }
  };

  const handleClick = evt => {
    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    if (onClick) onClick(evt);
  };

  return /*#__PURE__*/_jsx(Tag, Object.assign({}, rest, {
    "aria-disabled": disabled,
    className: classNames('private-clickable', className),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: buttonRef,
    tabIndex: getTabIndex(disabled, tabIndex, null)
  }));
};

UIClickableCore.displayName = 'UIClickable';
const UIClickable = styled(UIClickableCore).withConfig({
  displayName: "UIClickable",
  componentId: "sc-1nhmult-0"
})(["cursor:", ";"], ({
  cursor,
  disabled
}) => disabled ? 'not-allowed' : cursor);
UIClickable.displayName = 'Styled(UIClickable)';
UIClickable.propTypes = {
  autoFocus: PropTypes.bool,
  buttonRef: refObject,
  cursor: PropTypes.string,
  disabled: PropTypes.bool,
  tagName: PropTypes.string.isRequired
};
UIClickable.defaultProps = {
  cursor: 'pointer',
  role: 'button',
  tagName: 'div'
};
export default ShareButton(UIClickable);